module.exports = __webpack_public_path__ + "static/img/head4.b143fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head4.png
// module id = nJfl
// module chunks = 1